import commaUp from '../../../assets/images/solution/smart/comma-up.png'
import commaDown from '../../../assets/images/solution/smart/comma-down.png'

import styles from './style.module.scss'

function SmartPolicing() {
    return (
      <div
        className={`solution-introduction-wrapper ${styles['smart-wrapper']}`}
      >
        <div className={`banner ${styles['banner']}`}>
          <div className="title">智慧警务</div>
          <div className="content">
            集强大计算能力、海量资源整合、高度信息共享、智能应用服务、严密安全保障、警务运行支撑于一体的全栈解决方案
          </div>
        </div>
        <div
          className={`introduction-wrapper ${styles['introduction-wrapper']}`}
        >
          <p className="title">方案简介</p>
          <div
            className={`introduction-title ${styles['introduction-title']}`}
          >
            <div>
              <img src={commaUp} alt="" />
              <p>智慧警务</p>
              <p>
                集强大计算能力、海量资源整合、高度信息共享、智能应用服务、严密安全保障、警务运行支撑“六大体系”于一体的全栈解决方案
              </p>
              <img src={commaDown} alt="" />
            </div>
          </div>
        </div>
        <div
          className={`achievement-wrapper ${styles['achievement-wrapper']}`}
        >
          <p className="title">实践成果</p>
          <div
            className={`achievement-container ${styles['achievement-container']}`}
          >
            <div className={styles['achievement-item']}>
              <div className={styles['img']}></div>
              <p className={styles['sub-title']}>
                面向全警的服务支撑
              </p>
              <p className={styles['sub-content']}>
                网络安全、智慧决策、打击犯罪、治安防控、队伍管理等
              </p>
            </div>
            <div className={styles['achievement-item']}>
              <div className={styles['img']}></div>
              <p className={styles['sub-title']}>
                公安信息化建设经验丰富
              </p>
              <p className={styles['sub-content']}>
                31个省级单位
              </p>
              <p className={styles['sub-content']}>
                281市级单位
              </p>
              <p className={styles['sub-content']}>
                2000+区县单位
              </p>
            </div>
            <div className={styles['achievement-item']}>
              <div className={styles['img']}></div>
              <p className={styles['sub-title']}>
                每年协助公安侦办案件50000+
              </p>
              <div>
                <div>
                  <p className={styles['sub-content']}>
                    诈骗窝点，一网打尽
                  </p>
                  <p className={styles['sub-content']}>
                    严刹赌博歪风，净化社会环境
                  </p>
                  <p className={styles['sub-content']}>
                    追逃风暴来袭，重拳出击
                  </p>
                </div>
                <div>
                  <p className={styles['sub-content']}>
                    专业研判，精准缉私
                  </p>
                  <p className={styles['sub-content']}>
                    保护个人信息，狠打“内鬼”
                  </p>
                  <p className={styles['sub-content']}>…</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default SmartPolicing